import React, { useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'
import * as siteActions from '~/data/actions/siteActions'
import Button from '~/Common-Objects/UI/Forms/Button/Button'
import Column from '~/Common-Objects/Grids/Column/Column'
import Icons from '~/Common-Objects/UI/Icons/index'
import Paper from '~/Common-Objects/UI/Paper/Paper'
import Row from '~/Common-Objects/Grids/Row/Row'
import axios from '~/data/http/axios'
import DrawerAddCampaignStep1 from '~/pages/cp/campaigns/add/drawerAddCampaignStep1'
import FormPicker from '~/pages/cp/includes/formPicker'
import CreateAutomationModal from '~/pages/cp/includes/automations/createAutomationModal'
import helpers from '~/Classes/helpers'

export default function QuickLinks({ groupId, appData }) {
    const permissionStore = useSelector((state) => state.permission)
    const history = useHistory()
    const dispatch = useDispatch()
    const accountMaster = useSelector((state) => state.accountMaster)

    const addNewCampaign = () => {
        const drawerContent = <DrawerAddCampaignStep1 history={history} />
        dispatch(siteActions.alterSiteDrawer(true, false, 'left', drawerContent, true, 500, 'drawer_nopad'))
    }

    const addForm = () => {
        var drawer = <FormPicker save={formAdded} />
        dispatch(siteActions.alterSiteDrawer(true, true, 'right', drawer, true, '100%'))
    }

    const formAdded = async (theme, themeType, options) => {
        var form = {
            formName: '',
            wizard: {
                step1: true
            },
            options,
            ThemeId: theme.id,
            formType: themeType
        }

        let useEditorV2 = await helpers.getTemplateEditorVersion(accountMaster, true)

        return axios.post('/group/' + groupId + '/form', form).then((response) => {
            const editorUrl = useEditorV2.canUseV2 ? '/cp/templates/add/dragDropv2/' : '/cp/templates/add/dragDrop/'
            var redirect = '/cp/groups/' + groupId + '/forms/create/' + response.data.Form.id + '/2'
            history.push(
                editorUrl +
                    '?form=true&groupId=' +
                    groupId +
                    '&formId=' +
                    response.data.Form.id +
                    '&redirect=' +
                    redirect
            )
        })
    }

    return (
        <Row>
            <Column xs={12} className='no-marg'>
                <h4 className='mar-b20'>Quick Links</h4>
            </Column>
            {permissionStore.permissions.campaigns !== 'none' && (
                <Column xs={12} sm={6} className='mar-b25'>
                    <Paper className='height-100 mar-b0'>
                        <h4 className='mar-b10 quickFlex'>
                            <div style={{ display: 'inline-flex', marginRight: 10 }}>
                                <Icons icon='envelopeOpen' circle={true} />
                            </div>{' '}
                            Send
                        </h4>
                        <p>
                            Create and send email campaigns, AB split tests and more to your contacts en-mass. <br />
                            Then watch in real time as your emails get opened, links get clicked and much more.
                        </p>
                        <div className='quickFlex'>
                            {permissionStore.permissions.campaigns === 'write' && (
                                <Button
                                    iconLeft={<Icons icon='plus' />}
                                    text='Create a Campaign'
                                    className='mar-r10'
                                    onClick={addNewCampaign}
                                />
                            )}
                            <Button
                                text='View Campaigns'
                                className='button-primary'
                                onClick={() => history.push('/cp/campaigns')}
                            />
                        </div>
                    </Paper>
                </Column>
            )}
            {permissionStore.permissions.automations !== 'none' && (
                <Column xs={12} sm={6} className='mar-b25'>
                    <Paper className='height-100 mar-b0'>
                        <h4 className='mar-b10 quickFlex'>
                            <div style={{ display: 'inline-flex', marginRight: 10 }}>
                                <Icons icon='lightning' circle={true} />
                            </div>{' '}
                            Automate
                        </h4>
                        <p>
                            Automations are a great way to automatically make things happen based on your contacts
                            activity. <br />
                            For example, you could send a welcome email when someone gets added to {appData.appName}.
                        </p>
                        <div className='quickFlex'>
                            {permissionStore.permissions.automations === 'write' && (
                                <Button
                                    iconLeft={<Icons icon='plus' />}
                                    text='Add an Automation'
                                    className='mar-r10'
                                    onClick={() =>
                                        dispatch(
                                            alterFullpage(
                                                <CreateAutomationModal onClose={() => dispatch(alterFullpage(null))} />
                                            )
                                        )
                                    }
                                />
                            )}
                            <Button
                                text='View Automations'
                                className='button-primary'
                                onClick={() => history.push('/cp/automation')}
                            />
                        </div>
                    </Paper>
                </Column>
            )}
            {permissionStore.permissions.forms !== 'none' && (
                <Column xs={12} sm={6} className='mar-b25'>
                    <Paper className='height-100 mar-b0'>
                        <h4 className='mar-b10 quickFlex'>
                            <div style={{ display: 'inline-flex', marginRight: 10 }}>
                                <Icons icon='document' circle={true} />
                            </div>
                            Capture
                        </h4>
                        <p>
                            Design forms and capture new contacts, or find out a little more about existing contacts.{' '}
                            <br />
                            You can design fully hosted forms, or even forms you can embed on your website, social media
                            page and more.
                        </p>
                        <div className='quickFlex'>
                            <Button
                                iconLeft={<Icons icon='plus' />}
                                text='Create a Form'
                                onClick={addForm}
                            />
                        </div>
                    </Paper>
                </Column>
            )}
            {permissionStore.permissions.company === 'write' && (
                <Column xs={12} sm={6} className='mar-b25'>
                    <Paper className='height-100 mar-b0'>
                        <h4 className='mar-b10 quickFlex'>
                            <div style={{ display: 'inline-flex', marginRight: 10 }}>
                                <Icons icon='world' circle={true} />
                            </div>{' '}
                            Track
                        </h4>
                        <p>
                            Track contacts movements and interactions on your website after they have interacted with
                            your emails. <br />
                            Setup alerts when contacts visit certain pages, track conversions and much more.
                        </p>
                        <div className='quickFlex'>
                            <Button
                                iconLeft={<Icons icon='plus' />}
                                text='Setup Website Tracking'
                                onClick={() => history.push(`/cp/trackers`)}
                            />
                        </div>
                    </Paper>
                </Column>
            )}
        </Row>
    )
}
